import { welcomeTourExperience } from './WelcomeTourExperience';
import type { ComponentType } from 'react';

export type GuidedExperienceStepDefinition = {
  id: string;
  title: string;
  component: ComponentType;
};

export type GuidedExperienceDefinition = {
  id: string;
  title: string;
  version: string;
  priority: number;
  steps: GuidedExperienceStepDefinition[];
};

export const guidedExperiences: Record<string, GuidedExperienceDefinition> = {
  [welcomeTourExperience.id]: welcomeTourExperience,
};
